export const QR_LANGUAGE_STORAGE_KEY = "qr_order_language";

const QR_LANGUAGES = new Set(["en", "ja"]);

const isQrLanguage = (language?: string | null) =>
  Boolean(language && QR_LANGUAGES.has(language));

export const isQrOrderRoute = (pathname: string) =>
  pathname === "/qr-order" || pathname.startsWith("/qr-order/");

export const resolveQrLocale = (
  savedLanguage?: string | null,
  embeddedLanguage?: string | null
) => {
  if (isQrLanguage(savedLanguage)) return savedLanguage;
  if (isQrLanguage(embeddedLanguage)) return embeddedLanguage;
  return "ja";
};

export const getQrInitialLocale = (
  pathname: string,
  savedLanguage?: string | null,
  embeddedLanguage?: string | null
) => isQrOrderRoute(pathname) ? resolveQrLocale(savedLanguage, embeddedLanguage) : undefined;
